import React from 'react';
import {ReactComponent as Bin} from '../../../../assets/icon/bin.svg';
import {BinIconContainer} from './ModalIcon.styled';
import {IModalIconProps} from "./ModalIcon.helper";

export const BinIcon: React.FC<IModalIconProps> = ({clickHandler}) => {
  return <BinIconContainer onClick={clickHandler}><Bin/></BinIconContainer>;
};
